import { SECTOR_SHORT } from "@/lib/constants";

export function SectorBadge({ sector, className = "" }) {
  return (
    <span
      data-testid="sector-badge"
      className={`inline-flex items-center rounded-full px-3 py-1 text-[11px] tracking-wide 
        bg-[hsl(var(--pdg-gold)/0.10)] text-[hsl(var(--pdg-gold))] border border-[hsl(var(--pdg-gold)/0.25)] ${className}`}
    >
      {SECTOR_SHORT[sector] || sector}
    </span>
  );
}

const STATUS_STYLES = {
  pending: "bg-[hsl(38_22%_14%)] text-[hsl(38_45%_74%)] border-[hsl(38_22%_28%)]",
  verified: "bg-[hsl(145_18%_14%)] text-[hsl(145_38%_72%)] border-[hsl(145_18%_28%)]",
  declined: "bg-[hsl(0_22%_14%)] text-[hsl(0_45%_74%)] border-[hsl(0_22%_28%)]",
  published: "bg-[hsl(var(--pdg-gold)/0.10)] text-[hsl(var(--pdg-gold))] border-[hsl(var(--pdg-gold)/0.25)]",
  sourcing: "bg-[hsl(210_16%_14%)] text-[hsl(210_30%_76%)] border-[hsl(210_16%_28%)]",
  vetting: "bg-[hsl(38_22%_14%)] text-[hsl(38_45%_74%)] border-[hsl(38_22%_28%)]",
  underwriting: "bg-[hsl(268_16%_15%)] text-[hsl(268_30%_78%)] border-[hsl(268_16%_30%)]",
  ic_review: "bg-[hsl(200_16%_15%)] text-[hsl(200_30%_78%)] border-[hsl(200_16%_30%)]",
  archived: "bg-[hsl(220_8%_14%)] text-[hsl(220_8%_62%)] border-[hsl(220_8%_26%)]",
  approved: "bg-[hsl(145_18%_14%)] text-[hsl(145_38%_72%)] border-[hsl(145_18%_28%)]",
  submitted: "bg-[hsl(38_22%_14%)] text-[hsl(38_45%_74%)] border-[hsl(38_22%_28%)]",
  not_started: "bg-[hsl(220_8%_14%)] text-[hsl(220_8%_62%)] border-[hsl(220_8%_26%)]",
  sent: "bg-[hsl(145_18%_14%)] text-[hsl(145_38%_72%)] border-[hsl(145_18%_28%)]",
  failed: "bg-[hsl(0_22%_14%)] text-[hsl(0_45%_74%)] border-[hsl(0_22%_28%)]",
  suppressed: "bg-[hsl(220_8%_14%)] text-[hsl(220_8%_62%)] border-[hsl(220_8%_26%)]",
  delivered: "bg-[hsl(145_18%_14%)] text-[hsl(145_38%_72%)] border-[hsl(145_18%_28%)]",
  queued: "bg-[hsl(38_22%_14%)] text-[hsl(38_45%_74%)] border-[hsl(38_22%_28%)]",
  accepted: "bg-[hsl(145_18%_14%)] text-[hsl(145_38%_72%)] border-[hsl(145_18%_28%)]",
  rejected: "bg-[hsl(0_22%_14%)] text-[hsl(0_45%_74%)] border-[hsl(0_22%_28%)]",
  duplicate: "bg-[hsl(220_8%_14%)] text-[hsl(220_8%_62%)] border-[hsl(220_8%_26%)]",
  success: "bg-[hsl(145_18%_14%)] text-[hsl(145_38%_72%)] border-[hsl(145_18%_28%)]",
  attention: "bg-[hsl(38_22%_14%)] text-[hsl(38_45%_74%)] border-[hsl(38_22%_28%)]",
  error: "bg-[hsl(0_22%_14%)] text-[hsl(0_45%_74%)] border-[hsl(0_22%_28%)]",
};

export function StatusBadge({ status, label, className = "" }) {
  const key = (status || "").toLowerCase();
  const style = STATUS_STYLES[key] || "bg-[hsl(220_8%_14%)] text-[hsl(220_8%_70%)] border-[hsl(220_8%_26%)]";
  return (
    <span data-testid="status-badge"
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium border capitalize ${style} ${className}`}>
      {(label || status || "").replace(/_/g, " ")}
    </span>
  );
}
